import { render, staticRenderFns } from "./SupportTicketDialog.vue?vue&type=template&id=bbae9d30"
import script from "./SupportTicketDialog.vue?vue&type=script&lang=js"
export * from "./SupportTicketDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/common/Button.vue').default,ModalScreen: require('/vercel/path0/components/common/ModalScreen.vue').default})
